import store from '@/utils/storage'

const mutations = {
  setUserInfo(state, payload) {
    store.set('userInfo', payload)
    state.userInfo = payload
  },
  setCompanyId(state, payload) {
    store.set('companyId', payload)
    state.companyId = payload
  },
  setLogin(state, payload) {
    store.set('token', payload)
    state.token = payload
  },
  setCustomcmd(state, payload) {
    store.set('customcmd', payload)
    state.customcmd = payload
  },
  setShowHistory(state, payload) {
    store.set('showHistory', payload)
    state.showHistory = payload
  },
  setIsMobile(state, payload) {
    store.set('isMobile', payload)
    state.isMobile = payload
  },
  setAppScroll(state, payload) {
    store.set('appScroll', payload)
    state.appScroll = payload
  },
  setHistoryList(state, payload) {
    store.set('historyList', payload)
    state.historyList = payload
  },
  setFirstEnter(state, payload) {
    store.set('firstEnter', payload)
    state.firstEnter = payload
  },
  clearVuex(state, payload) {
    // ['token', 'userInfo', 'companyInfo']
    store.clearAll()
    state.isLogin = ''
    state.userInfo = {}
    state.companyInfo = {}
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js